import { useNotifyChange, useOnChange } from 'hooks/useChangeSignal';

// An appointment changed in its panel, or the planning placed one: the
// planning and the home page read them again.
export const PLANNING_CHANGED = 'planning_changed';

export const useNotifyPlanningChanged = () => useNotifyChange(PLANNING_CHANGED);

const usePlanningChanged = (onChanged) => useOnChange(PLANNING_CHANGED, onChanged);

export default usePlanningChanged;
